// extracted by mini-css-extract-plugin
export default {"hideScrollbar":"c6aa7012","container":"fe231f05","card":"d8020836"};